import { baseUrl, extendHeaders } from "./HelpService";


const PageUrl = baseUrl + 'stripe/';

const getPaymentMethods = (userId) => {
    const queryParams = new URLSearchParams();
    if (userId && userId !== undefined) {
        queryParams.set('userId', userId);
    }

    const search = queryParams.toString();
    return fetch(PageUrl + `getPaymentMethods/?${search}`, {
        method: "GET",
        headers: extendHeaders(),
    }).then((response: any) => response.json())
};

const createCustomer = (userId) => {
    return fetch(PageUrl + "createCustomer/", {
        method: "POST",
        headers: extendHeaders(),
        body: JSON.stringify({userId: userId})
    }).then((response: any) => response.json())
};

const getClientSecret = (payment_method_type, userId) => {
    const queryParams = new URLSearchParams();
    queryParams.set('paymentMethodType', payment_method_type);
    if (userId && userId !== undefined) {
        queryParams.set('userId', userId);
    }

    const search = queryParams.toString();

    return fetch(PageUrl + `getClientSecret/?${search}`, {
        method: "GET",
        headers: extendHeaders()
    }).then((response: any) => response.json())
};

const updatePaymentMethodToDefault = (paymnetMethodId, userId) => {
    return fetch(PageUrl + "updatePaymentMethodToDefault/", {
        method: "POST",
        headers: extendHeaders(),
        body: JSON.stringify({ paymentMethodId: paymnetMethodId, userId: userId })
    }).then((response: any) => response.json())
};

const acceptingFuturePayments = (paymnetMethodId, userId) => {
    return fetch(PageUrl + "acceptingFuturePayments/", {
        method: "POST",
        headers: extendHeaders(),
        body: JSON.stringify({ paymentMethodId: paymnetMethodId, userId: userId })
    }).then((response: any) => response.json())
};

const createBillingInvoice = (userId) => {
    return fetch(PageUrl + `createBillingInvoice/`, {
        method: "POST",
        headers: extendHeaders(),
        body: JSON.stringify({userId: userId})
    })
        .then((response: any) => response.json())
        .catch((error) => {
            return null;
        });
};

const chargeCustomer = (userId) => {
    return fetch(PageUrl + `chargeCustomer/`, {
        method: "POST",
        headers: extendHeaders(),
        body: JSON.stringify({userId: userId})
    })
        .then((response: any) => response.json())
        .catch((error) => {
            return null;
        });
};

const StripeService = {
    getPaymentMethods,
    createCustomer,
    getClientSecret,
    updatePaymentMethodToDefault,
    acceptingFuturePayments,
    createBillingInvoice,
    chargeCustomer
};

export default StripeService;
